module.exports = __webpack_public_path__ + "img/123123.31d56c86.png";